import { createFileRoute } from "@tanstack/react-router";
import { ChatBrowsePage } from "@/features/chatbrowse/ChatBrowsePage";

/** G719 chat channel browser (docs/frontend/PAGES.md P72). The channel list; each channel opens at /chat/$channel. */
export const Route = createFileRoute("/_app/chat/")({
  component: ChatBrowsePage,
});
